import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import Logo from "../../assets/images/MadeWithQubio.png";
import "./deletePage.css";

const DeletedPage = () => {
  const [deviceHeight, setDeviceHeight] = useState();

  useEffect(() => {
    setDeviceHeight(window.innerHeight);
  }, []);

  return (
    <div
      style={{
        padding: "1rem",
        backgroundColor: "#1F2937",
        margin: "0px auto",
        height: `calc(${deviceHeight}px)`,
      }}
    >
      <div className="deleted-container">
        <div className="reportBox">
          <span className="deleted-title">
            <FaTrash />
          </span>
          <span className="deleted-description">
            Sorry, this content has been deleted
          </span>
        </div>
        <div>
          <footer className="bottom-container">
            <img src={Logo} alt="" className="bottom-text" />
            <div className="footer-container">
              <a
                className="footer-link"
                href={"https://qubio.me"}
                target="_blank"
                rel="noreferrer"
              >
                <p className="footer-text">{"Learn more"}</p>
              </a>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default DeletedPage;
